
    <!--
 * 电脑端-统一平台通用底部
 * @LastEditTime: Thu Sep 19 2024 16:44:01 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_V2QT17"  :class="[`normal`,`u_c_V2QT17`]" ><div id="u_c_HU0S18"  v-show="compData.isM" :class="[`normal duan`,`u_c_HU0S18`]" ><div id="u_c_SZWR19"  :class="[`normal`,`u_c_SZWR19`]" ><div id="u_c_ORW020"  v-for="(logoItem, logoI) in compData.logoList" :key="logoI" :style="`background-image:url(${ logoItem.pic })`" :class="[`u_c_ORW020_${logoI}`,`normal logo`,`u_c_ORW020`]" ></div></div><div id="u_c_SE5U21"  :class="[`normal`,`u_c_SE5U21`]" ><a id="u_c_VCLD22" target="_blank" v-for="(linkItem, linkI) in compData.linkList" :key="linkI" :href="linkItem.link" :class="[`normal txt link`,`u_c_VCLD22`]" @click="u_c_VCLD22_event_XNIH17($event,linkItem.link)">{{`${ linkItem.txt }`}}</a></div><div id="u_c_L88S24"  :class="[`normal txt`,`u_c_L88S24`]" >{{`${ compData.copyright }`}}</div></div><div id="u_c_MTNB26"  v-show="!compData.isM" :class="[`normal duan`,`u_c_MTNB26`]" ><div id="u_c_RBJ727"  :class="[`normal`,`u_c_RBJ727`]" ><div id="u_c_UVK828"  v-for="(logoItem, logoI) in compData.logoList" :key="logoI" :style="`background-image:url(${ logoItem.pic })`" :class="[`u_c_UVK828_${logoI}`,`normal logo`,`u_c_UVK828`]" ></div></div><div id="u_c_NPOD29"  :class="[`normal`,`u_c_NPOD29`]" ><div id="u_c_SPFL30"  :class="[`normal`,`u_c_SPFL30`]" ><a id="u_c_SRKW31" target="_blank" v-for="(linkItem, linkI) in compData.linkList" :key="linkI" :href="linkItem.link" :class="[`normal txt link`,`u_c_SRKW31`]" @click="u_c_SRKW31_event_ZLXN18($event,linkItem.link)">{{`${ linkItem.txt }`}}</a></div><div id="u_c_QEHW33"  :class="[`normal txt`,`u_c_QEHW33`]" >{{`${ compData.copyright }`}}</div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"copyright":"© 自动替换年份 自动替换域名, Ltd. All Rights Reserved.","linkList":[{txt:"自动根据语言生成",link:""},{txt:"自动根据语言生成",link:""}],"logoList":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16774803643733.png"},{"pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726734948439-33.png"},{"pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726734948438-55.png"},{"pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726734948436-26.png"}],"isM":false,"s_fwtk":``,"s_yszc":``,"s_zzf":``,"s_sqf":``},"en-US":{"copyright":"© 自动替换年份 自动替换域名, Ltd. All Rights Reserved.","linkList":[{txt:"自动根据语言生成",link:""},{txt:"自动根据语言生成",link:""}],"logoList":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16774803643733.png"},{"pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726734948439-33.png"},{"pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726734948438-55.png"},{"pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726734948436-26.png"}],"isM":false,"s_fwtk":``,"s_yszc":``,"s_zzf":``,"s_sqf":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const DEFAULT_LINK = {
  fwtk: `https://gpassport.${utils.getMainHost()}/center/ServicePrivacy/service?language=${curLang}&gameId=${
    pageData.gameId
  }`,
  yszc: `https://gpassport.${utils.getMainHost()}/center/ServicePrivacy/privacy?language=${curLang}&gameId=${
    pageData.gameId
  }`,
}

const DEFAULT_LINK_JP = {
  fwtk: `https://gpassport.${utils.getMainHost()}/center/JpServicePrivacy/service`,
  yszc: `https://gpassport.${utils.getMainHost()}/center/JpServicePrivacy/privacy`,
  zzf: `https://gpassport.${utils.getMainHost()}/center/JpServicePrivacy/customize?keyWord=jzsws`,
  sqf: `https://gpassport.${utils.getMainHost()}/center/JpServicePrivacy/customize?keyWord=busisws`,
}

const getMainHostName = window.location.hostname.split(".")[1] || ""
compData.copyright = `© ${vueUse.formatDate(
  new Date(),
  "YYYY"
)} ${getMainHostName.toUpperCase()}, Ltd. All Rights Reserved.`

compData.linkList = []
if (langData["fwtk"]) {
  let curLink = DEFAULT_LINK.fwtk
  if (curLang == "ja-JP") {
    curLink = DEFAULT_LINK_JP.fwtk
  }
  if (compData.s_fwtk) {
    curLink = compData.s_fwtk
  }
  compData.linkList.push({
    txt: langData["fwtk"],
    link: curLink,
  })
}

if (langData["yszc"]) {
  let curLink = DEFAULT_LINK.yszc
  if (curLang == "ja-JP") {
    curLink = DEFAULT_LINK_JP.yszc
  }
  if (compData.s_yszc) {
    curLink = compData.s_yszc
  }
  compData.linkList.push({
    txt: langData["yszc"],
    link: curLink,
  })
}

if (langData["zzf"]) {
  let curLink = DEFAULT_LINK_JP.zzf
  if (compData.s_zzf) {
    curLink = compData.s_zzf
  }
  compData.linkList.push({
    txt: langData["zzf"],
    link: curLink,
  })
}

if (langData["sqf"]) {
  let curLink = DEFAULT_LINK_JP.sqf
  if (compData.s_sqf) {
    curLink = compData.s_sqf
  }
  compData.linkList.push({
    txt: langData["sqf"],
    link: curLink,
  })
};
      // 超链的click事件
      const u_c_VCLD22_event_XNIH17= async (e,link)=>{
        try {
bridge.callSdkMethod('openBrowser', {
            url: link,
            loginDir: 0,
            appendParams: 0,
          });
} catch (error) {console.log(error)}
      };
      // 超链的click事件
      const u_c_SRKW31_event_ZLXN18= async (e,link)=>{
        try {
bridge.callSdkMethod('openBrowser', {
            url: link,
            loginDir: 0,
            appendParams: 0,
          });
} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_V2QT17.normal{
position:relative;

}

.u_c_V2QT17.normal .txt{
font-size:1.85vh;
color:#bcbcbc;

}

.u_c_V2QT17.normal .link{
padding:0 2.78vh;

}

.u_c_V2QT17.normal .link::after{
content:"|";
position:absolute;
right:0;
top:50%;
transform:translateY(-50%);

}

.u_c_V2QT17.normal .link:last-child::after{
content:"";

}

.u_c_V2QT17.normal .link:last-child{
padding-right:0;

}

.u_c_V2QT17.normal .link:first-child{
padding-left:0;

}

.u_c_V2QT17.normal .logo{
margin:0.93vh 1.85vh;

}

.u_c_V2QT17.normal .logo:first-child{
margin-left:0;

}

.u_c_V2QT17.normal .logo:last-child{
margin-right:0;

}

.u_c_V2QT17.normal .duan{
background-color:#272a2c;
box-sizing:border-box;

}
}.default{
.u_c_HU0S18.normal{
position:relative;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
width:69.44vh;
padding:3.70vh 0;
margin:auto;

}
}.default{
.u_c_SZWR19.normal{
position:relative;
background:no-repeat center;
background-size:contain;
display:flex;
flex-flow:wrap;
justify-content:center;

}
}.default{
.u_c_ORW020.normal{
position:relative;
width:20.00vh;
height:4.72vh;
background:no-repeat center;
background-size:contain;

}

.u_c_ORW020.u_c_ORW020_0{
width:20.00vh;
height:4.72vh;

}

.u_c_ORW020.u_c_ORW020_1{
width:6.67vh;
height:6.67vh;

}

.u_c_ORW020.u_c_ORW020_2{
width:6.67vh;
height:6.67vh;

}

.u_c_ORW020.u_c_ORW020_3{
width:6.67vh;
height:6.67vh;

}
}.default{
.u_c_SE5U21.normal{
position:relative;
margin-top:0.93vh;
box-sizing:border-box;
padding:0 1.85vh;
text-align:center;

}
}.default{
.u_c_VCLD22.normal{
position:relative;
width:18.52vh;
height:9.26vh;
work-break:keep-all;
white-space:nowrap;

}
}.default{
.u_c_L88S24.normal{
position:relative;
margin-top:1.48vh;

}
}.default{
.u_c_MTNB26.normal{
position:relative;
display:flex;
justify-content:space-between;
align-items:center;
width:177.78vh;
padding:2.78vh 18.52vh;
box-sizing:border-box;
margin:auto;

}
}.default{
.u_c_RBJ727.normal{
position:relative;
background:no-repeat center;
background-size:contain;
display:flex;
align-items:center;

}
}.default{
.u_c_UVK828.normal{
position:relative;
width:18.61vh;
height:3.24vh;
background:no-repeat center;
background-size:contain;

}

.u_c_UVK828.u_c_UVK828_0{
width:18.61vh;
height:3.24vh;

}

.u_c_UVK828.u_c_UVK828_1{
width:6.67vh;
height:6.67vh;

}

.u_c_UVK828.u_c_UVK828_2{
width:6.67vh;
height:6.67vh;

}

.u_c_UVK828.u_c_UVK828_3{
width:6.67vh;
height:6.67vh;

}
}.default{
.u_c_NPOD29.normal{
position:relative;
display:flex;
flex-direction:column;
justify-content:flex-end;
align-items:flex-end;

}
}.default{
.u_c_SPFL30.normal{
position:relative;
text-align:right;

}
}.default{
.u_c_SRKW31.normal{
position:relative;
width:18.52vh;
height:9.26vh;
work-break:keep-all;
white-space:nowrap;

}
}.default{
.u_c_QEHW33.normal{
position:relative;
margin-top:0.93vh;

}
}.en-US{
.u_c_V2QT17.normal{
position:relative;

}

.u_c_V2QT17.normal .txt{
font-size:1.85vh;
color:#bcbcbc;

}

.u_c_V2QT17.normal .link{
padding:0 2.78vh;

}

.u_c_V2QT17.normal .link::after{
content:"|";
position:absolute;
right:0;
top:50%;
transform:translateY(-50%);

}

.u_c_V2QT17.normal .link:last-child::after{
content:"";

}

.u_c_V2QT17.normal .link:last-child{
padding-right:0;

}

.u_c_V2QT17.normal .link:first-child{
padding-left:0;

}

.u_c_V2QT17.normal .logo{
margin:0.93vh 1.85vh;

}

.u_c_V2QT17.normal .logo:first-child{
margin-left:0;

}

.u_c_V2QT17.normal .logo:last-child{
margin-right:0;

}

.u_c_V2QT17.normal .duan{
background-color:#272a2c;
box-sizing:border-box;

}
}.en-US{
.u_c_HU0S18.normal{
position:relative;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
width:69.44vh;
padding:3.70vh 0;
margin:auto;

}
}.en-US{
.u_c_SZWR19.normal{
position:relative;
background:no-repeat center;
background-size:contain;
display:flex;
flex-flow:wrap;
justify-content:center;

}
}.en-US{
.u_c_ORW020.normal{
position:relative;
width:20.00vh;
height:4.72vh;
background:no-repeat center;
background-size:contain;

}

.u_c_ORW020.u_c_ORW020_0{
width:20.00vh;
height:4.72vh;

}

.u_c_ORW020.u_c_ORW020_1{
width:6.67vh;
height:6.67vh;

}

.u_c_ORW020.u_c_ORW020_2{
width:6.67vh;
height:6.67vh;

}

.u_c_ORW020.u_c_ORW020_3{
width:6.67vh;
height:6.67vh;

}
}.en-US{
.u_c_SE5U21.normal{
position:relative;
margin-top:0.93vh;
box-sizing:border-box;
padding:0 1.85vh;
text-align:center;

}
}.en-US{
.u_c_VCLD22.normal{
position:relative;
width:18.52vh;
height:9.26vh;
work-break:keep-all;
white-space:nowrap;

}
}.en-US{
.u_c_L88S24.normal{
position:relative;
margin-top:1.48vh;

}
}.en-US{
.u_c_MTNB26.normal{
position:relative;
display:flex;
justify-content:space-between;
align-items:center;
width:177.78vh;
padding:2.78vh 18.52vh;
box-sizing:border-box;
margin:auto;

}
}.en-US{
.u_c_RBJ727.normal{
position:relative;
background:no-repeat center;
background-size:contain;
display:flex;
align-items:center;

}
}.en-US{
.u_c_UVK828.normal{
position:relative;
width:18.61vh;
height:3.24vh;
background:no-repeat center;
background-size:contain;

}

.u_c_UVK828.u_c_UVK828_0{
width:18.61vh;
height:3.24vh;

}

.u_c_UVK828.u_c_UVK828_1{
width:6.67vh;
height:6.67vh;

}

.u_c_UVK828.u_c_UVK828_2{
width:6.67vh;
height:6.67vh;

}

.u_c_UVK828.u_c_UVK828_3{
width:6.67vh;
height:6.67vh;

}
}.en-US{
.u_c_NPOD29.normal{
position:relative;
display:flex;
flex-direction:column;
justify-content:flex-end;
align-items:flex-end;

}
}.en-US{
.u_c_SPFL30.normal{
position:relative;
text-align:right;

}
}.en-US{
.u_c_SRKW31.normal{
position:relative;
width:18.52vh;
height:9.26vh;
work-break:keep-all;
white-space:nowrap;

}
}.en-US{
.u_c_QEHW33.normal{
position:relative;
margin-top:0.93vh;

}
}
</style>
